<template>
  <transition name="fade" @enter="enter" @beforeEnter="beforeEnter" appear>
    <div class="scene-wrap" v-if="this.scenes.opening">
      <video
        class="enter-video"
        id="enter-video"
        muted
        playsinline
        preload
      >
        <source src="/media/opening_animation_v2.mp4" type="video/mp4" />
      </video>

        <!-- <audio
          ref="audio"
          preload
          loop
          autoplay
          src="/media/opening.mp3"
          type="audio/mp3"
          class="audio-opening"
          data-autoplay
        ></audio> -->

    </div>
  </transition>
</template>

<script>
import $ from "jquery";
// import Loading from "./Loading.vue";

export default {
  name: "Video",
  props: ["scenes","isTest"],
  data() {
    return {
      loaded: 0,
    };
  },
  components: {
    // Loading,
  },
  mounted() {
    // document.onreadystatechange = () => {
    //   if (document.readyState == "complete") {
    //     // run code here
    //     console.log("loadedddddd");
    //     this.emitter.emit("finish-loading");
    //   }
    // };
    this.emitter.on("hide-loading", () => {
      if (this.scenes.opening && $(".enter-video")[0]) {
        $(".enter-video")[0].play();
      }
      // console.log("[loading] show scene");
    });
  },

  methods: {
    // --------
    // ENTERING
    // --------
    // the done callback is optional when
    // used in combination with CSS
    beforeEnter() {
      this.emitter.emit("start-loading");
    },
    enter(el, done) {
      // console.log(el);
      console.log("[opening video]: enter");  

      const videoElement = document.getElementById("enter-video");
      videoElement.addEventListener("suspend", () => {
        // suspend invoked
        // show play button
        // iphone is in low power mode
        // console.log("low battery mode");
        if (videoElement.paused) {
          $(".enter-video").attr("controls", true);
        }
      });

      videoElement.addEventListener("play", () => {
        // video is played
        // remove play button UI
        // iphone is not in low power mode
        // console.log("hide controls");
        $(".enter-video").attr("controls", false);
      });

      $("#enter-video")[0].onended = function () {
        // video ended
        console.log("video finished");
        $(".video-wrap").addClass("wrap-hide");
        setTimeout(function () {}, 100);
        // this.$emit("VideoToMap");
        this.emitter.emit("hide-opening");
        // this.emitter.emit("show-loading");
      }.bind(this);

      console.log("video transition: enter");

      var vid = document.getElementById("enter-video");
      vid.playbackRate = 1;
      if(this.isTest){
        vid.playbackRate=15;
      }

      // $(".enter-video")[0].play();
      // on video end

      // this.$nextTick(function () {
      //   console.log("[Scene] loaded");
      //   this.emitter.emit("finish-loading");
      // });
      done();
    },
  },
};
</script>
